<template>
    <div class="modal fade slide-up disable-scroll in" 
        :id="modalId" 
        tabindex="-1" 
        role="dialog" 
        :aria-labelledby="modalId + 'Label'" 
        aria-hidden="false"
        style="display: block; padding-right: 15px;"
    >
        <div class="modal-dialog ">
            <div class="modal-content-wrapper">
                <div class="modal-content">
                    <div class="loader" v-if="isLoading">
                        <div class="progress-circle-indeterminate"></div>
                    </div>

                    <div class="modal-header clearfix text-left">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="onExit">
                        <i class="pg-close fs-14"></i>
                        </button>

                        <h5>{{ modalTitle }}</h5>
                    </div>
                    
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isLoading: false
            }
        },

        props: {
            modalId: {
                type: String,
                required: true
            },
            modalTitle: {
                type: String,
                default: ''
            }
        },

        mounted() {
            $('body').addClass('modal-open')
        },

        beforeDestroy() {
            $('body').removeClass('modal-open')
        },

        methods: {
            closeModal() {
                this.$emit('modal-closed', this.modalId)
            },

            onExit() {
                this.closeModal()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal.fade.slide-up.disable-scroll.in {
        background-color: rgba(0, 0, 0, 0.75);
    }

    .loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(235, 235, 235, 0.5);
        z-index: 10;

        .progress-circle-indeterminate {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 30px;
            height: 30px;
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Modals/SlideUpModal.vue